/** A date string as the browser's short local date, or "N/A" when there is none. */
export const formatDateOrNA = (dateString) => (dateString ? new Date(dateString).toLocaleDateString() : 'N/A');
